// C:\react-js\my-app\src\components\signup.js
import { useState } from 'react';
import Axios from 'axios';
import loginimg from '../images/logo.jpg';
import figuraemail from '../images/email.png';
import senha from '../images/password.png';
import usuario from '../images/usuario.png';
import '../css/styles.css';

const SignUp = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [registerStatus, setRegisterStatus] = useState('');

  const register = (e) => {
    e.preventDefault(); // Previne o comportamento padrão de recarregar a página
    Axios.post('/api/register', {
      email: email,
      name: name,
      password: password,
    }).then((response) => {
      console.log(response);
      if (response.data.message) {
        setRegisterStatus(response.data.message);
      } else {
        setRegisterStatus('Conta criada com sucesso');
      }
    }).catch((error) => { // Adicionando tratamento de erro básico
        console.error("Erro no registro:", error);
        setRegisterStatus("Erro ao criar conta. Tente novamente.");
    });
  };

  return (
    <div className="container-principal">
      <form className="containerdashboardlogin" onSubmit={register}>
        <div className="col-12">
          <div className="logologin">
            <img src={loginimg} alt="Logo de Login" className="img-fluid" />
          </div>
          <h1 className="letralogin">Crie a sua conta</h1>

          {registerStatus && <p className="register-status-message">{registerStatus}</p>}

          {/* Grupo para Nome */}
          <div className="form-group-with-icon">
            <img width="40" height="40" src={usuario} alt="Ícone de Usuário" />
            <input
              type="text"
              className="form-control form-control-lg"
              placeholder="Entre com seu nome"
              onChange={(e) => {
                setName(e.target.value);
              }}
              required
            />
          </div>

          {/* Grupo para Email */}
          <div className="form-group-with-icon">
            <img width="40" height="40" src={figuraemail} alt="Ícone de Email" />
            <input
              type="email"
              placeholder="Entre com o seu email"
              className="form-control form-control-lg"
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              required
            />
          </div>

          {/* Grupo para Senha */}
          <div className="form-group-with-icon">
            <img width="40" height="40" src={senha} alt="Ícone de Senha" />
            <input
              type="password"
              className="form-control form-control-lg"
              placeholder="Entre com a sua senha"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              required
            />
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <p className="small fw-bold mt-2 pt-1 mb-0 text-white "></p>
          </div>

          <div className="text-center text-white mt-4 pt-2">
            <button
              type="submit" 
              className="btn btn-primary btn-lg"
            >
              Cadastre-se
            </button>
            <p className="small fw-bold mt-2 pt-1 mb-0">
              Login para sua conta{' '}
              <a href="login" className="link-danger">
                Login
              </a>
            </p>
          </div>
        </div>
      </form>
    </div>
  );
};

export default SignUp;